export default __webpack_public_path__ + "static/media/royal-vault.56ddf72c.webp";